import { render, staticRenderFns } from "./VStatus.vue?vue&type=template&id=409761cb&scoped=true&lang=pug"
import script from "./VStatus.vue?vue&type=script&lang=ts"
export * from "./VStatus.vue?vue&type=script&lang=ts"
import style0 from "./VStatus.vue?vue&type=style&index=0&id=409761cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409761cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
